<template>
	<div class="">
		<div class="information">
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input @focus="getFocus" v-model="oldPassword" ref="inputFocus" type="password" name="" id="" placeholder="请填写旧密码" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input @focus="getFocus" v-model="password" ref="inputFocus" type="password" name="" id="" placeholder="请填写新密码" value="" />
			</div>
			<div class="information_div">
				<div class="information_div_div">
					<img class="img_sjh" src="../assets/group_pass.png" />
				</div>
				<input @focus="getFocus" v-model="confirmPassword" ref="inputFocus" type="password" name="" id="" placeholder="请确认密码" value="" />
			</div>
		</div>
		<div class="buttom_bc" @click="changePass" v-show="showBtn">
			保存
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'ChangePassword',
		data() {
			return {
				oldPassword: "",
				password: "",
				confirmPassword: "",
				success: false,
				success_img: false,
				success_text: "",
				baseUrl: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true
			}
		},
		methods: {
			getFocus() {    
				$("input").on("blur", function() {        
					window.scroll(0, 0);    
				});
			},
			changePass() {
				var that = this;
				var pass_reg = /^[a-zA-Z0-9]+$/;
				    var reg = /^(((?=.*[a-z])+(?=.*[A-Z])+(?=.*\d)+)|((?=.*[A-Z])+(?=.*[a-z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+)|((?=.*\d)+(?=.*[A-Z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+)|((?=.*\d)+(?=.*[a-z])+(?=.*[`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|])+))[A-Za-z\d`~!@#$%^&*()+={}':;',.<>?~！@#￥%……&*（）——+{}【】‘；：”“’。，、？\|]{8,20}$/
				if(that.oldPassword == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请填写旧密码';
				} else if(!pass_reg.test(that.oldPassword)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '密码格式错误';
				} else if(that.password == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请填写新密码';
				} else if(!reg.test(that.password)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请使用数字、大小写字母，特殊字符中3种组合成8-16位密码';
				} else if(that.password != that.confirmPassword && that.confirmPassword == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '两次密码不一致';
				} else {
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "POST",
						url: that.baseUrl + "/tickets/tickets/ajax?ugi=userUgi&action=updatePWD",
						dataType: "json",
						async: true,
						data: {
							oldPassword: that.oldPassword,
							password: that.password,
							confirmPassword: that.confirmPassword
						},
						success: function(data) {
							if(data.code == 'A00006') {
								that.success = true;
								that.success_img = true;
								that.success_text = '修改成功';
							}else if(data.code == 'A00001') {
								that.success = true;
								that.success_img = false;
								that.success_text = '系统繁忙，请稍后再试';
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = data.errmsg;
							}
						}
					});
				}
			},
			determine() {
				var that = this;
				if(that.success_text == "修改成功") {
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "GET",
						url: that.baseUrl + '/tickets/tickets/ajax?ugi=loginUgi&action=logoutLogin',
						dataType: "json",
						async: true,
						data: {

						},
						success: function(data) {
							if(data.code == 'A00006') {
								sessionStorage.removeItem("name");
								that.$router.push({
									name: "Loading"
								})
							}
						}
					});
				} else {
					that.success = false;
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "https://www.xiangshan1949.cn";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
		}
	}
</script>

<style scoped>
	body {
		width: 100%;
		height: 100vh;
		background: white;
		overflow: hidden;
	}
	
	.information {
		width: 80%;
		border-radius: 15px;
		overflow: hidden;
		padding: 0 5%;
		margin: 20px auto 0;
		-webkit-overflow-scrolling: touch;
		background: white;
	}
	
	.img_gr {
		width: 16px;
	}
	
	.img_sfz {
		width: 22px;
	}
	
	.img_sjh {
		width: 16px;
	}
	
	.information_div {
		display: flex;
		border-bottom: 1px #eee solid;
		align-items: center;
		justify-content: space-between;
	}
	
	.information_div_div {
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	input {
		width: 85%;
		border: none;
		outline: none;
		font-size: 16px;
		line-height: 60px;
	}
	
	.buttom_bc {
		width: 60%;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 39px;
		border-radius: 48px;
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		margin: 0 auto;
		position: fixed;
		left: 50%;
		bottom: 2%;
		margin-left: -30%;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 23%;
		margin-left: 39%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 80%;
		color: black;
		font-size: 17px;
		font-weight: 600;
		text-align: center;
		margin: 20px auto 0;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
</style>


// WEBPACK FOOTER //
// src/components/changePassword.vue